<template>
  <div>

    <h1 class="title font-weight-bold mt-2 mb-4">Últimos dados registrados</h1>
    <v-row align="center">
      <v-col cols="12" md="12" class="mt-2">
        <v-icon class="mr-2" size="16" color="white" style="height: 24px; width: 24px; border-radius: 50%; background-color: #69d7a3;">icon-infohidro-bacia</v-icon>
        <span v-if="location" class="pt-1" style="font-size: 16px;">{{ location.text }}</span>
        <span v-else class="pt-1" style="font-size: 16px;">Estado do Paraná</span>
      </v-col>
    </v-row>

    <v-row v-if="showAnimation">

      <v-col cols="12">
        <v-card color="primary darken-1">
          <div style="height: 300px">
            <loading-animation @loopComplete="loadAnimationComplete"></loading-animation>
          </div>
        </v-card>
      </v-col>
    </v-row>

    <div v-else>

      <v-row v-if="sizeWidth < 1440">

        <v-col class="d-flex justify-space-between" cols="12">
          <card-ice class="mr-2" :width="width" min-width="200"></card-ice>

          <card-granting-effluents
            class="ml-2"
            :grantsEffluentsTotal="grantsEffluentsTotal"
            :grantsEffluents="grantsEffluents"
            :location="location"
            :indicator="
              indicator.find((item) => item.indicador === 'efluentes')
            "
            :width="width"
            min-width="200"
          ></card-granting-effluents>
        </v-col>

        <v-col class="d-flex justify-space-between" cols="12">
          <card-bovines class="mr-2" :width="width" min-width="200"></card-bovines>

          <card-pesticides
            class="ml-2"
            :toxic="pesticides"
            :indicator="
              indicator.find((item) => item.palavrachave === 'agrotoxico')
            "
            :location="location"
            :width="width"
            min-width="200"
          ></card-pesticides>
        </v-col>

        <v-col class="d-flex justify-space-between" cols="12">
          <CardErosion class="mr-2" :width="width" min-width="200">
          </CardErosion>

          <CardEnvironmentalRestrictions class="ml-2"
            :width="width"
            min-width="200"
            :location="location"
          ></CardEnvironmentalRestrictions>
        </v-col>

        <v-col class="d-flex justify-space-between" cols="12">
          <card-use-soil
            class="mr-2"
            :location="location"
            :indicator="
              indicator.find((item) => item.indicador === 'usos do solo')
            "
            :usoSolo="usoSolo"
            :width="width"
            min-width="200"
          ></card-use-soil>

          <card-estimation
            class="ml-2"
            :width="width"
            min-width="200"
            :location="location"
            :indicator="
              indicators.find((item) => item.indicador === 'carga difusa')
            "
            :carga="carga"
          ></card-estimation>
        </v-col>
      </v-row>

      <v-row no-gutters v-else>

        <v-col class="d-flex justify-space-between" :cols="sizeWidth <= 2400 ? '12' : '6'">
          <card-ice :class="sizeWidth > 2400 ? 'mr-3' : 'my-5 mr-5'" :width="width" :min-width="minWidth"></card-ice>

          <card-granting-effluents
            :class="sizeWidth > 2400 ? 'mx-3' : 'my-5 mx-5'"
            :grantsEffluentsTotal="grantsEffluentsTotal"
            :grantsEffluents="grantsEffluents"
            :location="location"
            :indicator="
              indicator.find((item) => item.indicador === 'efluentes')
            "
            :width="width"
            :min-width="minWidth"
          ></card-granting-effluents>

          <card-bovines :class="sizeWidth > 2400 ? 'mx-3' : 'my-5 mx-5'" :width="width"
            :min-width="minWidth"></card-bovines>

          <card-pesticides
            :class="sizeWidth > 2400 ? 'mx-3' : 'my-5 ml-5'"
            :toxic="pesticides"
            :indicator="
              indicator.find((item) => item.palavrachave === 'agrotoxico')
            "
            :location="location"
            :width="width"
            :min-width="minWidth"
          ></card-pesticides>
        </v-col>

        <v-col class="d-flex justify-space-between" :cols="sizeWidth >= 1440 && sizeWidth <= 2400 ? '12' : '6'">
          <CardErosion
            :class="sizeWidth > 2400 ? 'mx-3' : 'my-5 mr-5'"
            :width="width"
            :min-width="minWidth">
          </CardErosion>

          <CardEnvironmentalRestrictions
            :class="sizeWidth > 2400 ? 'mx-3' : 'my-5 mx-5'"
            :location="location"
            :width="width"
            :min-width="minWidth">
          </CardEnvironmentalRestrictions>

          <card-use-soil
            :class="sizeWidth > 2400 ? 'mx-3' : 'my-5 mx-5'"
            :location="location"
            :indicator="
              indicator.find((item) => item.indicador === 'usos do solo')
            "
            :usoSolo="usoSolo"
            :width="width"
            :min-width="minWidth">
          </card-use-soil>

          <card-estimation
            :class="sizeWidth > 2400 ? 'ml-3' : 'my-5 ml-5'"
            :width="width"
            :min-width="minWidth"
            :location="location"
            :indicator="
              indicators.find((item) => item.indicador === 'carga difusa')
            "
            :carga="carga">
          </card-estimation>
        </v-col>

      </v-row> <!-- fim if -->

    </div>
  </div>
</template>

<script>
import CardEstimation from '@/components/indicators/IndicatorsCardsItems/CardEstimation';
import CardPesticides from '@/components/indicators/IndicatorsCardsItems/CardPesticides';
import CardGrantingEffluents from '@/components/indicators/IndicatorsCardsItems/CardGrantingEffluents';
import CardUseSoil from '@/components/indicators/IndicatorsCardsItems/CardUseSoil';
import CardBovines from '@/components/indicators/IndicatorsCardsItems/CardBovines';
import CardEnvironmentalRestrictions from '@/components/indicators/IndicatorsCardsItems/CardEnvironmentalRestrictions';
import CardIce from '@/components/indicators/IndicatorsCardsItems/CardIce';
import CardErosion from '@/components/indicators/IndicatorsCardsItems/CardErosion';
import LoadingAnimation from '@/components/common/LoadingAnimation';
import { mapGetters } from 'vuex';

export default {
  name: 'IndicatorsCards',
  props: {
    location: {
      required: true,
    },
  },
  components: {
    LoadingAnimation,
    CardIce,
    CardUseSoil,
    CardGrantingEffluents,
    CardPesticides,
    CardEstimation,
    CardBovines,
    CardEnvironmentalRestrictions,
    CardErosion,
  },
  data() {
    return {
      minWidth: 240,
      width: 400,
      loading: false,
      showAnimation: false,
      sizeWidth: 0,
    };
  },
  created() {
    this.initialize(this.location);
    this.initializeErosion(this.location);
    this.initializeBovines(this.location);
    this.initializeRestriction(this.location);
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
    this.sizeWidth = window.innerWidth;
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  watch: {
    async location(value) {
      if (value) {
        await this.initialize(value);
        this.initializeErosion(value);
        this.initializeBovines(value);
        this.initializeRestriction(value);
      }
    },
  },
  computed: {
    ...mapGetters(['indicator']),
    grantsEffluentsTotal() {
      if (this.$store.getters.grantsEffluents) {
        if (this.$store.getters.grantsEffluents.length === 0) {
          return this.$store.getters.grantsEffluentsTotal;
        } else {
          return undefined;
        }
      } else {
        return this.$store.getters.grantsEffluentsTotal;
      }
    },
    grantsEffluents() {
      const aux = this.$store.getters.grantsEffluents;
      if(aux.totalFormatted){
        const stringToArrAux = aux.totalFormatted.split(" ");
        let intAux = parseInt(stringToArrAux[stringToArrAux.length - 1]);
        intAux = new Intl.NumberFormat("pt-BR").format(intAux);
        stringToArrAux[stringToArrAux.length - 1] = intAux.toString();
        aux.totalFormatted = stringToArrAux.toString().replaceAll(",", " ");
      }
      return aux;
    },
    indicators() {
      return this.$store.getters.indicator;
    },
    usoSolo() {
      return this.$store.getters.usoSolo;
    },
    pesticides() {
      return this.$store.getters.agrotoxico;
    },
    carga() {
      return this.$store.getters.cargas;
    },
  },

  methods: {
    loadAnimationComplete() {
      this.showAnimation = this.loading;
    },
    async initialize(value) {
      this.showAnimation = true;
      this.loading = true;
      await this.$store.dispatch('loadIndicator', {indicadores: []});
      if (value) {
        await this.$store.dispatch('loadSiaDetails', { // deprecate
          location_id: value?.locationid,
        });
        await this.$store.dispatch('loadSaneparLocations', {
          locationIds: [value?.locationid],
          ref: "SIA",
        });
      }
      const sia = await this.$store.getters.siaDetails;
      await this.$store.dispatch('loadOutorgasEfluentesTotal', {sias: []});
      if (sia) {
        await this.$store.dispatch('loadIndicatorCarga', {
          sias: [sia?.locacronymn],
        });
        await this.$store.dispatch('loadOutorgasEfluentes', {
          sias: [sia?.locacronymn],
        });
        await this.$store.dispatch('loadUsoSolo', {sias: [sia?.locacronymn]});
        await this.$store.dispatch('loadAgrotoxico', {
          sias: [sia?.locacronymn],
        });
      }
      this.loading = false;
    },

    async initializeErosion(value) {
      if (!value) {
        await this.$store.dispatch('loadIndicatorErosionTotal', {
          indicadores: ['erosao'],
        });
        return;
      }
      else {
        await this.$store.dispatch('loadSiaDetails', {
          location_id: value?.locationid,
        });
        const sia = await this.$store.getters.siaDetails;
        await this.$store.dispatch('loadIndicatorErosionSia', {
          sias: [sia?.locacronymn],
        });
        return;
      }
    },

    async initializeBovines(value) {
      this.showAnimation = true;
      this.loading = true;
      if (value) {
        await this.$store.dispatch('loadSiaDetails', {
          location_id: value?.locationid,
        });
        const sia = await this.$store.getters.siaDetails;
        await this.$store.dispatch('loadIndicatorBovinesSia', {
          sias: [sia?.locacronymn],
        });
      }
      this.loading = false;
    },

    async initializeRestriction(value) {
      this.showAnimation = true;
      this.loading = true;
      if (!value) {
        await this.$store.dispatch('loadIndicatorRestriction', {
         indicadores: ['restricoes ambientais'],
        });
      }
      else {
        const sia = await this.$store.getters.saneparLocations;
        await this.$store.dispatch('loadRestricoesAmbientais', {
          sias: [sia[0]?.acronym],
        });
      }
      this.loading = false;
    },
    handleResize() {
      this.sizeWidth = window.innerWidth;
    },
  },
};
</script>
